module.exports = __webpack_public_path__ + "img/hand stop.617ee308.svg";